<template>
  <div class="popup-overlay" @click="closePopup">
    <div class="popup-content" @click.stop>
      <div class="popup-body">
        <div class="title-container">
          <h2 class="popup-title">Como ajustar sua foto</h2>
        </div>

        <div class="image-container">
          <img
            draggable="false"
            @contextmenu.prevent
            @dragstart.prevent
            :src="gifSrc"
            alt="Instruções de edição"
            class="instruction-image"
          />
        </div>

        <div class="button-container">
          <button class="continue-button" @click="continuarEditando">
            ENTENDI, CONTINUAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupInstrucoes",
  props: {
    tipoFoto: {
      type: String,
      required: true,
    },
  },
  computed: {
    gifSrc() {
      // Retorna o GIF correto baseado no tipo de foto
      if (this.tipoFoto === "polaroid") {
        return "/img/icons/GIF POLAROIDE.gif";
      } else {
        // Para fotos normais, 3x4 e passaporte, mostra o GIF comum
        return "/img/icons/GIF COMUM.gif";
      }
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
    continuarEditando() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background: white;
  border-radius: 16px;
  padding: 0;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-container {
  width: 100%;
  padding: 24px 24px 16px 24px;
  text-align: center;
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}

.popup-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.instruction-image {
  max-width: 100%;
  max-height: 60vh;
  width: auto;
  height: auto;
  display: block;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.continue-button {
  background: #8c2667;
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  box-shadow: 0px 4px 8px rgba(162, 134, 199, 0.25);
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 12px rgba(162, 134, 199, 0.35);
}

.continue-button:active {
  transform: translateY(0);
}

/* Responsivo para mobile */
@media (max-width: 768px) {
  .popup-content {
    margin: 20px;
    max-width: calc(100vw - 40px);
  }

  .popup-title {
    font-size: 20px;
  }

  .title-container {
    padding: 20px 20px 12px 20px;
  }

  .button-container {
    padding: 20px;
  }

  .continue-button {
    padding: 14px 20px;
    font-size: 16px;
  }

  .instruction-image {
    max-height: 50vh;
  }
}

/* Para telas muito pequenas */
@media (max-width: 480px) {
  .popup-content {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }

  .popup-title {
    font-size: 18px;
  }

  .title-container {
    padding: 16px 16px 8px 16px;
  }

  .button-container {
    padding: 16px;
  }

  .instruction-image {
    max-height: 45vh;
  }
}
</style>
